import styled from "styled-components";

export const CardStyled = styled.div`
  cursor: ${(props) => (props?.onClick ? "pointer" : "arrow")};
`;

export const FeatureSelectionStyled = styled.div`
  .widget-content {
    padding: 24px 36px;
    display: grid;
    height: calc(100vh - 56px);
    grid-template-columns: 1fr 1fr;

    .user {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  .timesheet{
    background-color: #E4F9DC;
    justify-content: space-between;

    .img{
    display: flex;
      align-self: end;
      justify-content: center;
    img{
      width: 80%
    }
  }
  }

  .time{ 
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    justify-content: space-between;
  }

  .projectList{
    background-color: #FFDCAD;
    justify-content: space-between;
    .img{
      display: flex;
      align-self: end;
      justify-content: end;
      img{
        width: 80%;
      }
    }
  }

  .list{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    justify-content: space-between;
  }
  .icon{
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .feature-tiles {
    display: grid;
    grid-template-columns: 1fr;
    flex-direction: column;
    gap: 10px;

    .flex {
      display: flex;
      padding: 12px;
      align-items: flex-start;
      flex: 1 0 0;
      align-self: stretch;
      overflow: hidden;
      .corner {
        display: flex;
        align-items: center;
        text-decoration: underline;
        gap: 5px;
        cursor: pointer;
      }
      &:hover {
        transform: scale(0.95);
      }
    }
  }
`;
